import React from 'react';
import Icon from '../shared/Icon';

/**
 * Every state of the review body except "there is work to do": the two spinner
 * phases, the load failure, and the empty queue.
 *
 * Kept together because they share one centred layout and one exit button —
 * the reviewer's only move in all four is to wait or to leave.
 */
const DocumentReviewPhases = ({ phase, error, committedCount, onClose }) => {
  if (phase === 'loading' || phase === 'submitting') {
    return (
      <div className="docreview-loading">
        <Icon name="hourglass_top" className="docreview-loading-icon" size={40} />
        <p className="docreview-loading-text">
          {phase === 'loading' ? 'Loading fields that need review...' : 'Saving this document...'}
        </p>
      </div>
    );
  }

  if (phase === 'failed') {
    return (
      <div className="docreview-centered">
        <Icon name="error_outline" className="docreview-centered-error-icon" size={40} />
        <p className="docreview-centered-text">{error || 'Failed to load review data'}</p>
        <button className="docreview-button docreview-button-tertiary" onClick={onClose}>
          Close
        </button>
      </div>
    );
  }

  // Nothing left: either finished in this session, or nothing was flagged.
  return (
    <div className="docreview-centered">
      <Icon name="check_circle" className="docreview-centered-done-icon" size={40} />
      {/* An error here means the queue emptied because a document changed
          underneath the reviewer, not because everything was confident. */}
      <p className="docreview-centered-title">
        {committedCount > 0
          ? 'Review complete'
          : error ? 'Nothing left to review' : 'All fields look confident'}
      </p>
      <p className="docreview-centered-text">
        {committedCount > 0
          ? `${committedCount} document${committedCount === 1 ? '' : 's'} reviewed. Processing has resumed.`
          : error || 'Every extracted field cleared the confidence floor — nothing to review here.'}
      </p>
      <button className="docreview-button docreview-button-tertiary" onClick={onClose}>
        Back to datasets
      </button>
    </div>
  );
};

export default DocumentReviewPhases;
